import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { IData } from '../../helpers/interface';
import { useEffect, useState } from 'react';
import axios from 'axios';

interface IProps {
  moduleData: IData;
  isView: boolean;
  handleSumbit: any;
  autoCompleteMachineValue: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
  setIsOpenPopupRejections: any;
  setRejectionsIndx: any;
  setReasonType: any;
}

const TController = ({
  moduleData,
  isView,
  handleSumbit,
  autoCompleteMachineValue,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
  setIsOpenPopupRejections,
  setRejectionsIndx,
  setReasonType,
}: IProps) => {
  const [processData, setProcessData] = useState({});

  useEffect(() => {
    axios
      .get('/api/processRoutes/processList/processForAutoComplete')
      .then((res) => {
        if (res.data) {
          setProcessData(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            setIsOpenPopup,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handleSumbit,
            processData,
            autoCompleteMachineValue,
            handelDeleteRows,
            isOpenPopup,
            setIsOpenPopup,
            setPartIdx,
            setIsOpenPopupRejections,
            setRejectionsIndx,
            setReasonType,
          }}
        />
        {/* <TFoot {...{ moduleData, isView }} /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
